const data = {
	hostname: 'abarthautomotive.com.au',
	id: 'abarthautomotive',
	bookingLink: 'https://book.repairy.au/abarthautomotive',
	name: 'Abarth Automotive',
	logo: '/images/AbarthAutomotive/logo.png',
	heroImage: '/images/AbarthAutomotive/hero.webp',
	theme: '#ff0000',
	intro: 'Experienced South Melbourne workshop with over 25 years in the industry. Partnered with Chapel Automotive, we deliver honest, high-quality servicing and repairs for all makes and models — backed by innovation and integrity.',
	googleAds: {
		metaTitle: 'Book service — Abarth Automotive, South Melbourne',
		metaDescription:
			'Book logbook servicing, basic service, tyres and balancing, and battery work online at Abarth Automotive, South Melbourne.',
		eyebrow: 'Abarth Automotive',
		headline: 'Book for logbook servicing, tyres or a basic service online',
		subheadline:
			'Manufacturer-schedule logbook servicing, essential maintenance and inspections, tyres (replacement, rotation, balancing and alignment), and battery inspection and replacement.',
		bullets: [
			'Logbook services — manufacturer recommended schedule',
			'Tyres and balancing — replacement, rotation, alignment and wheel work',
			'Basic service plus battery inspection and replacement',
			'Book online — your slot is reserved instantly',
		],
		primaryCta: 'Book now',
	},
	services: [
		{
			id: 1,
			type: 'Basic Service',
			content: 'Essential maintenance and inspection service',
		},
		{
			id: 2,
			type: 'Logbook Services',
			content: 'Manufacturer recommended service schedule',
		},
		{
			id: 3,
			type: 'Tyres & Balancing',
			content: 'Tyre replacement, rotation, balancing, alignment, and wheel services',
		},
		{
			id: 4,
			type: 'Battery replacement',
			content: 'No start? Slow Start? Battery Light On?',
		}
	],
	otherServices: [
		'Tyres & Alignment',
		'Wheel Alignment',
		'Tyre Specialist',
		'Brake & Clutch Services',
		'Engine Diagnostic',
		'Steering & suspension',
	],
	reasons: [
		{
			id: 1,
			image: '/images/AbarthAutomotive/performance.jpg',
			title: '25+ Years of Experience',
			desc:
				'With decades of industry experience, our team combines traditional mechanical skill with modern diagnostic expertise.',
		},
		{
			id: 2,
			image: '/images/AbarthAutomotive/quality.jpg',
			title: 'Honest, Reliable Service',
			desc:
				'We pride ourselves on transparent communication, fair pricing, and customer-first service on every job.',
		},
		{
			id: 3,
			image: '/images/AbarthAutomotive/innovation.jpg',
			title: 'Driven by Innovation',
			desc:
				'Partnered with Ghostwriter, we embrace technology and continuous improvement to redefine quality automotive care.',
		},
	],
	about: {
		image: '/images/AbarthAutomotive/owner.webp',
		content: [
			<div key="sub-header">About Abarth Automotive</div>,
			<div key="header">Over 25 Years of Trusted Automotive Excellence</div>,
			<div key="content">
				Abarth Automotive, partnered with Chapel Automotive, is an established motor
				mechanic workshop in South Melbourne with over 25 years of experience in the
				automotive industry. We take pride in our workmanship, and our team is known for
				being skilled, friendly, and honest.
				<br />
				<br />
				In addition to new tyres and puncture repairs, we service and repair all makes
				and models at competitive prices. Our commitment to quality automotive care is
				defined by innovation — a value we share with our partner, Ghostwriter — as we
				continue to redefine excellence in the automotive service industry.
				<br />
				<br />
				We perform full logbook servicing and utilise the latest diagnostic equipment
				to ensure every vehicle receives precise and professional care.
				<br />
				<br />
				<span style={{ fontSize: '1.4rem', fontWeight: '500' }}>
					Jimmy
				</span>
				<br />
				<span style={{ fontSize: '0.9rem' }}>
					Owner - Abarth Automotive.
				</span>
			</div>,
		],
	},
	reviews: [
		{
			link:
				'https://www.google.com/search?q=Abarth+Automotive+and+Tyres&oq=Abarth+Automotive+and+Tyres&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIHCAEQABiABDIICAIQABgWGB4yDQgDEAAYhgMYgAQYigUyDQgEEAAYhgMYgAQYigUyBggFEEUYPDIGCAYQRRg8MgYIBxBFGDzSAQgxMDYyajBqN6gCALACAA&sourceid=chrome&ie=UTF-8&zx=1761216260180&no_sw_cr=1#lrd=0x6ad667ff79f691a3:0x7aa36c8e0b41d9b9,1,,,,',
			score: '4.9',
			totalReview: '103',
			type: 'Google',
		},
		{
			link: 'https://www.facebook.com/abarthautomotive/reviews',
			score: '4.8',
			totalReview: '12',
			type: 'Facebook',
		},
	],
	contacts: {
		googleMap:
			'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.3409623969724!2d144.9583020759786!3d-37.82890297197174!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad667ff79f691a3%3A0x7aa36c8e0b41d9b9!2sAbarth%20Automotive%20and%20Tyres!5e0!3m2!1sen!2sid!4v1761217985718!5m2!1sen!2sid',
		address: ['22-24 Market Street,', 'South Melbourne, VIC 3205.'],
		phone: '03 9690 4348',
		email: 'jimmy@abarthautomotive.com.au',
		opening: ['Monday - Friday: 8am - 5pm', 'Saturday: 8am - 12pm'],
	},
	isExtraLogos: true,
	extraLogos: [
		'/images/Others/continental-logo.png',
		'/images/Others/pirelli-logo.png',
		'/images/Others/bridgestone-logo.png',
		'/images/Others/VACC.png',
	],
};

export default data;
